import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Curso {
  slug: string;
  titulo: string;
  descricao: string;
  imagem: string;
  duracao: string;
}

@Injectable({
  providedIn: 'root'
})
export class CursosService {
  private cursosUrl = '/assets/cursos.json';

  constructor(private http: HttpClient) {}

  public getCursoBySlug(slug: string): Observable<Curso | undefined> {
    return this.http.get<Curso[]>(this.cursosUrl).pipe(
      map(cursos => cursos.find(curso => curso.slug === slug))
    );
  }
}
